import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Intro(props) {
  const { t } = useTranslation();
  const isLeft = props.location === 'left';

  const textContent = (
    <div className="lg:w-1/2 flex flex-col justify-center py-2 lg:py-0">
      <h3 className="text-xl font-bold text-[#162E3B] mb-6">
        {props.title}
      </h3>
      <p className="text-gray-700 text-base leading-relaxed mb-8 text-left">
        {props.text}
      </p>
      {props.extratext && (
        <p className="text-gray-700 text-base leading-relaxed mb-8 text-left">
          {props.extratext}
        </p>
      )}
      
      {/* Premium, high-contrast action button (replaces inline link) */}
      <div className="flex justify-start">
        <Link
          to={props.pathname}
          className="inline-flex items-center justify-center px-6 py-3 bg-[#FFD82D] text-[#162E3B] font-extrabold text-base rounded-xl shadow-md border-2 border-transparent hover:bg-[#162E3B] hover:text-white hover:border-[#162E3B] focus:outline-none focus:ring-4 focus:ring-[#FFD82D] active:scale-98 transition-all duration-200"
        >
          {t('home.intro.exploreCta', { title: props.title })}
        </Link>
      </div>
    </div>
  );

  const imgContent = (
    <div className="lg:w-1/2 flex items-center justify-center">
      <img
        className="w-full h-[320px] sm:h-[400px] lg:h-[460px] object-cover rounded-2xl shadow-lg border border-gray-100"
        src={props.img}
        alt={props.description}
      />
    </div>
  );

  return (
    <section className="py-6 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-16 items-stretch">
          {isLeft ? (
            <>
              {textContent}
              {imgContent}
            </>
          ) : (
            <div className="flex flex-col-reverse lg:flex-row gap-4 lg:gap-16 items-stretch w-full">
              {imgContent}
              {textContent}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Intro;
